const a = '<svg xmlns="http://www.w3.org/2000/svg" data-icon-kind="lucide" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8m4 2V6"/></svg>';
export {
  a as w
};
